import React, { useState } from 'react';
import NewSectionTitle from '@components/shared/NewSectionTitle';
import Image from 'next/image';
import callIcon from '@assets/icons/placement-page/call-icon.svg';
import faqBottomImage from '@assets/placementpage-images/man-women.png';
import thumbsUpIcon from '@assets/placementpage-images/thumbs-up.svg';
import leftSideLine from '@assets/placementpage-images/left-side-lines.svg';
import { isArray } from 'lodash';
import useMediaQuery from '@utils/hooks/useMediaQuery';

const Faq = ({ placementPage, faqData }) => {
  const [openIndex, setOpenIndex] = useState(0);
  const isMobile = useMediaQuery('max-width: 767.98px');

  const placementFAQs =
    faqData
      ?.find((item) => item.faqCategory === 'Placements') // Get the object with 'Placements' category
      ?.FAQ.map((faq) => ({
        question: faq.question,
        answer: faq.answer,
      })) || [];

  const faqs = [
    {
      question: "Who can enroll in AlmaBetter's courses?",
      answer: 'Dreamers, hustlers, and go-getters, our students come from all walks of life.',
    },
    {
      question: 'What is a Cohort?',
      answer: 'A cohort is a group of students who learn together in a structured manner.',
    },
    {
      question: "Is there any selection test for enrolling in AlmaBetter's courses?",
      answer: 'No, there is no selection test required.',
    },
    {
      question: 'Is it mandatory to opt for the AlmaX Career Track?',
      answer: 'No, it is optional based on your career goals.',
    },
  ];
  const visibleFaqs = placementFAQs?.length > 0 ? placementFAQs : faqs;

  return (
    <div className="relative mx-auto flex max-w-6xl flex-col gap-8 px-6 py-12 pb-20 md:flex-row">
      <div className="mr-10 flex flex-col items-start gap-2 space-y-4 md:w-1/2">
        <div className="flex flex-col items-center md:mr-44">
          <NewSectionTitle
            text="Frequently Asked"
            highlightedText="Questions"
            placementPage={placementPage}
            isMobile={isMobile}
          />
        </div>
        <div className="">
          <p className="font-proxima-nova text-[14px] font-normal leading-[24px] text-[#1F1F1F] md:text-[16px]">
            Dreamers, hustlers, and go-getters, our <br /> students come from all walks of life.
          </p>
        </div>

        <div className="rounded-lg">
          <button className="flex h-12 items-center justify-center gap-3 rounded-lg bg-[#F00037] px-[24px] py-[8px] text-black md:px-[24px] md:py-[8px]">
            <Image alt='call-icon' src={callIcon} width={18} height={18} />
            <span className="font-proxima-nova text-[14px] font-medium capitalize tracking-wider text-[#F7F7F7] md:text-[18px]">
              Request Call Back
            </span>
          </button>
        </div>
      </div>
      
      <div className="mr-8 space-y-2 md:w-1/2">
        {/* {isArray(placementFAQs) && placementFAQs.length != 0 && placementFAQs?.map((faq, index)  => ( */}
        {visibleFaqs?.map((faq, index) => (
          <div
            key={index}
            className={`rounded-lg border p-4 transition-colors duration-300 ${
              openIndex === index
                ? 'border-[rgba(240,0,55,0.16)] bg-[#FFF6F8]'
                : 'border-[rgba(0,0,0,0.06)] bg-[#FFF]'
            }`}
          >
            <button
              className={`flex w-full items-center justify-between text-left transition-colors duration-300 ${
                openIndex === index
                  ? 'font-proxima-nova text-[16px] font-semibold leading-[25.6px] text-[#1F1F1F]'
                  : 'font-proxima-nova text-[16px] font-medium leading-[25.6px] text-[#1F1F1F]'
              }`}
              onClick={() => setOpenIndex(openIndex === index ? null : index)}
            >
              <span className="normal-case">{faq.question}</span>

              <span className="ml-2 flex h-6 w-6 items-center justify-center text-[#F00037]">
                {openIndex === index ? '−' : '+'}
              </span>
            </button>

            {openIndex === index && (
              <p className="mt-2 font-proxima-nova text-[14px] font-normal normal-case leading-[21px] text-[#1F1F1F]">
                {faq.answer}
              </p>
            )}
          </div>
        ))}
      </div>

      <div className="absolute bottom-0 left-0 mb-8 mt-12 hidden flex-shrink-0 md:block">
        <div className="absolute -top-4 -right-1 z-10">
          <Image
            src={thumbsUpIcon}
            width={40}
            height={40}
            alt="Thumbs up"
            className="drop-shadow-md"
          />
        </div>
        <Image
          src={faqBottomImage}
          width={250}
          height={200}
          alt="FAQ illustration"
          className="mb-16 ml-4"
        />
      </div>
    </div>
  );
};

export default Faq;
